<app-modal-shell [workspace]="true"
  [workspaceLayout]="'single'"
  [dismissLabel]="'general.close' | translate"
  (dismiss)="dismiss()">
  <div modalTitle>
    {{ 'schedule.title' | translate }}
  </div>

  <div modalDescription>
    {{ 'users.directory.views.allocation' | translate }}
  </div>

  <section modalMain
    class="allocation-workspace__main">
    <app-schedule [initialDate]="initialDate()"
      [initialUserGuid]="initialUserGuid()"
      [shiftEditContext]="shiftEditContext()"></app-schedule>
  </section>

  <div modalFooter>
<ion-button fill="clear"
        color="medium"
        (click)="dismiss()">
        {{ 'general.close' | translate }}
      </ion-button>
</div>
</app-modal-shell>
